import { createRootRoute } from '@tanstack/react-router';

export const rootRoute = createRootRoute({});
